/* eslint-disable react/prefer-es6-class, radix, react/sort-comp */
import React from 'react';
import Localization from 'es6/services/localization';
import * as Paths from 'es6/core/paths';

/**
 * A modal for adding items to a custom series.
 */
export default React.createClass({
  displayName: 'AddToCoursesModal',

  propTypes: {
    goals: React.PropTypes.array.isRequired,
    onClose: React.PropTypes.func.isRequired,
    onSubmit: React.PropTypes.func.isRequired,
  },

  /**
   * Callback handling form submission. Just pass up the
   * goal ID that is selected.
   */
  _handleSubmit() {
    this.props.onSubmit(parseInt(this.refs.goalMenu.value));
  },

  render() {
    const goals = this.props.goals;

    if (goals.length === 0) {
      return this._renderNoCourses();
    }

    return (
      <div className="content-container add-to-courses-modal">
        {this._renderHeader()}

        <div className="content-primary">
          <p dangerouslySetInnerHTML={{ __html: Localization.t('choose a course') }} />

          <select ref="goalMenu">
            {this.props.goals.map(goal => (
              <option key={goal.id} value={goal.id}>{goal.title}</option>
            ))}
          </select>
        </div>

        <footer className="content-actions">
          <button className="btn btn-bar" onClick={this._handleSubmit}>{Localization.t('add items')}</button>
        </footer>
      </div>
    );
  },

  _renderHeader() {
    return (
      <header className="content-details">
        <div className="details-primary">{Localization.t('add to courses')}</div>
        <div className="details-secondary">
          <span className="glyph glyph-cross-soft" onClick={this.props.onClose} />
        </div>
      </header>
    );
  },

  _renderNoCourses() {
    return (
      <div className="content-container add-to-courses-modal">
        {this._renderHeader()}

        <div className="content-primary">
          <p dangerouslySetInnerHTML={{ __html: Localization.t('you have no custom courses to add items') }} />
        </div>

        <footer className="content-actions">
          <a className="btn btn-bar" href={Paths.createCustomCourse()}>{Localization.t('create custom course')}</a>
        </footer>
      </div>
    );
  },
});
